import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putControlGroup } from '../Api'

export default generateApiAction({
  baseType: Types.CTRL_GROUPS.PUT,
  api: putControlGroup,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/controlGroups/PutAction.js